<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="user-settings" fluid pt-0>
    <v-app-bar app color="black" dark fixed>
      <template v-if="$vuetify.breakpoint.mdAndDown">
        <hb-main-menu-button/>
      </template>

      <v-toolbar-title v-if="!loading" style="margin-left: 0">{{ $tc('henkilo.title', 2) }}</v-toolbar-title>

      <v-spacer></v-spacer>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="!loading">
        <v-col class="mt-2" cols="12" offset-xl="1" xl="10">
          <v-row>
            <v-col cols="12">
              <v-card color="#191919" outlined>
                <v-card-title primary-title>

                  {{ $tc('henkilo.title', 2) }}
                  <v-spacer></v-spacer>

                  <v-btn color="primary" icon @click="addNewUser()">
                    <v-icon>mdi mdi-plus</v-icon>
                  </v-btn>
                </v-card-title>
                <v-divider/>

                <v-card-text>
                  <v-data-table :headers="headers"
                                :items="users"
                                :loading="subtleLoading"
                                class="mt-2"
                                disable-pagination
                                hide-default-footer
                  >
                    <template v-slot:item.nimi="{item}">
                      {{ `${item.firstname} ${item.lastname}` }}
                    </template>
                    <template v-slot:item.vastuualueLinkit="{item}">
                      
                      <span v-for="(linkki,i) in item.vastuualueLinkit" :key="i">
                        {{ linkki.vastuualue.nimi }} ({{ $t(`henkilo.roles.${linkki.rooli}`) }})
                        <br/>
                      </span>

                    </template>
                    <template v-slot:item._="{item}">
                      <td class="text-end">
                        <v-btn icon @click="editUser(item)">
                          <v-icon small>mdi mdi-pencil</v-icon>
                        </v-btn>
                      </td>
                    </template>
                  </v-data-table>
                </v-card-text>

              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-fade-transition>
    <henkilo-dialog ref="henkiloDialog" :users="users" @saved="reload"/>
  </v-container>
</template>

<script>

import apicollection from "../apicollection";
import HenkiloDialog from "../components/Henkilot/HenkiloDialog";

export default {

  name: 'HenkilotView',
  components: {HenkiloDialog},
  data() {
    return {
      loading: true,
      subtleLoading: false,
      users: [],
      headers: [
        {
          text: this.$t('henkilo.nimi'),
          value: 'nimi',
        },
        {
          text: this.$t('henkilo.email'),
          value: 'email'
        },
        {
          text: this.$t('henkilo.paavastuualueLinkit'),
          value: 'vastuualueLinkit'
        },
        {
          text: '',
          value: '_',
          sortable: false
        }
      ]
    };
  },
  computed: {},
  methods: {
    async getUsers() {
      try {
        const users = await apicollection.getUsers();
        this.users = users;
      } catch (e) {
        console.log(e);
        this.$showErrorNotification(this.$t('henkilo.api.get_users_failed'))
      }
    },
    addNewUser() {
      this.$refs.henkiloDialog.open();
    },
    editUser(user) {
      this.$refs.henkiloDialog.open(user);
    },
    async reload() {
      this.subtleLoading = true;
      await this.getUsers();
      this.subtleLoading = false;
    }
  },
  async mounted() {
    this.loading = true;
    await this.reload();
    this.loading = false;

    await this.$vuetify.goTo(0, {
      duration: 0,
      offset: 0,
    });
  },
};
</script>

<style lang="scss" scoped>

</style>